import { useEffect, useState } from 'react'
import { consumirApi } from '../../utils/consumoApi'
import { API_BASE_URL } from '../../utils/config.js' 
import { agregarDatosEmpresaUsuario } from '../../utils/empresaUsuario'
import { useAsyncError, useNavigate } from 'react-router-dom'
import { subYears, getYear, format } from 'date-fns'
import ErrorAlert from '../../components/common/ErrorAlert'
import Table from '../../components/tables/TableFilter'
import Button from '../../components/common/Button'
import Notification from '../../components/common/Notification'
import Spinner from '../../components/common/Spinner'
import Modal from '../../components/modals/Modal'
import Form from '../../components/forms/Form'
import Input from '../../components/common/Input'
import { FaFileExcel  } from "react-icons/fa"


const Cotizaciones = () => {
  const [datos, setDatos] = useState([])
  const [datosPaquetesCotizacion, setDatosPaquetesCotizacion] = useState([])
  const [datosPlazosCotizacion, setDatosPlazosCotizacion] = useState([])
  const [selectedId, setSelectedId] = useState(null) // Manejar el ID seleccionado de un proyecto
  const [selectedEstadoContrato, setSelectedEstadoContrato] = useState(null) // Manejar el ID seleccionado de un proyecto
  const [selectedDocumento, setSelectedDocumento] = useState(null) // Manejar el documneto seleccionado de un proyecto
  const [filtroEstado, setFiltroEstado] = useState('1') // Por defecto "1" (ACTIVO)
  const [estadoContrato, setEstadoContrato] = useState('0') // Por defecto "1" (ACTIVO)
  const [idProyecto, setIdProyecto] = useState('')
  const [estadoProyecto, setEstadoProyecto] = useState('')
  const [anioProyecto, setAnioProyecto] = useState(getYear(new Date()))
  const [contextMenu, setContextMenu] = useState({ visible: false, x: 0, y: 0, data: null })
  const navigate = useNavigate()
  // registro de contrato 
  const [fechaContrato, setFechaContrato] = useState(format(new Date(), 'yyyy-MM-dd'))
  const [selectedIdPaquete, setSelectedIdPaquete] = useState('') //id del paquete seleccionado para contrato 
  const [selectedPaquete, setSelectedPaquete] = useState([]) //datos compeltos del paquete seleccionado 
  const [tramitesSeleccionados, setTramitesSeleccionados] = useState([]) //datos del tramite seleccioando 

  // modales
  const [mostrarModalContrato, setMostrarModalContrato] = useState(false)
  const [mostrarModalEditar, setMostrarModalEditar] = useState(false)
  // Notificaciones y cargas
  const [cargando, setCargando] = useState(true)
  const [cargandoPdf, setCargandoPdf] = useState(false)
  const [error, setError] = useState("")
  const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const idEmpresa = JSON.parse(localStorage.getItem('empresa'))



  const columnas = [
    { titulo: 'id', campo: 'id' },
    { titulo: 'Cotización', campo: 'numero' },
    { titulo: 'Documento', campo: 'documento_cliente' },
    { titulo: 'Nombres', campo: 'clientes' },
    { titulo: 'Tipo Proyecto', campo: 'tipo_proyecto' },
    { titulo: 'Nombre Proyecto', campo: 'nombre_proyecto' },
    { titulo: 'Fecha Cotización', campo: 'fecha_cotizacion' },
    { titulo: 'Estado', campo: 'estado' },
  ]

  useEffect(() => {
    obtenerCotizaciones()
  }, [filtroEstado, estadoContrato, anioProyecto]) // Llamar a la función al cambiar el filtro

  const obtenerCotizaciones = async () => {
    const respuesta = await consumirApi('GET', `cotizacion/${idEmpresa}/${filtroEstado}/${estadoContrato}/${anioProyecto}`)
    setDatos(respuesta.success ? respuesta.data : [])
    setCargando(false)
  }

  // Manejar selección de checkbox
  const seleccionCotizacion = (data) => {
    setSelectedId((prevSelectedId) => (prevSelectedId === data.id ? null : data.id))
    setSelectedDocumento(data.documento_cliente)
    setSelectedEstadoContrato(data.estado_contrato)
  }

  // generar y abrir PDF de la cotizacion 
  const manejadorPdf = async () => {
    setCargandoPdf(true)

    try {
      const respuesta = await consumirApi('GET', `cotizacion/generar-pdf/${idEmpresa}/${selectedId}`)

      if (respuesta.data.success) {
        window.open(respuesta.data.url, '_blank')
      } else {
        setError('Error al generar el PDF:', respuesta.data.message)
      }
    } catch (error) {
      setError('Error en el manejador PDF:', error)
    } finally {
      setCargandoPdf(false)
    }
  }

  //editar una cotizacion
  const editarCotizacion = async (data) => {
    setIdProyecto(data.id)
    setSelectedEstadoContrato(data.estado_contrato)

    if (!data.estado_contrato) {
      navigate("/editar_cotizacion", { state: { id: data.id } })
    }
  }

  const manejadorContrato = async () => {
    setMostrarModalContrato(true)
    const respuesta = await consumirApi('GET', `contrato/paquetes/${selectedId}`)
    setDatosPaquetesCotizacion(respuesta.success ? respuesta.data : [])
    setDatosPlazosCotizacion(respuesta.success ? respuesta.data.cotizacionPlazo[0].plazos : [])
  }

  // seleccionar paquete 
  const seleccionPaquete = (idPaqueteSeleccionado) => {
    setSelectedIdPaquete(idPaqueteSeleccionado)

    // Filtrar el paquete seleccionado de los datos de la cotización
    const paqueteSeleccionado = datosPaquetesCotizacion.cotizaciones
      .flatMap(cotizacion => cotizacion.cotizacionDetalle)
      .find(detalle => detalle.paquete_id == idPaqueteSeleccionado)
    setSelectedPaquete(paqueteSeleccionado)
  }

  const groupedTramites = (datosPlazosCotizacion).reduce((acc, item) => {
    const tramite = item.plazo_detalle.plazo.tramite
    if (!acc[tramite]) acc[tramite] = []
    acc[tramite].push(item)
    return acc
  }, {})


  const handleChange = (tramite) => {
    setTramitesSeleccionados((prev) => {
      const nuevosDetalles = groupedTramites[tramite].map((item) => ({
        plazo_detalle_id: item.plazo_detalle_id,
        dias: item.dias
      }))

      // Verificamos si ya están todos los detalles en el estado actual
      const existe = nuevosDetalles.every((detalle) =>
        prev.some((item) => item.plazo_detalle_id === detalle.plazo_detalle_id)
      )

      if (existe) {
        // Si ya están, los eliminamos
        return prev.filter(
          (item) => !nuevosDetalles.some((detalle) => detalle.plazo_detalle_id === item.plazo_detalle_id)
        )
      } else {
        // Si no están, los agregamos
        return [...prev, ...nuevosDetalles]
      }
    })
  }

  const registrarContrato = async (e) => {
    setError('')
    e.preventDefault()

    if (!selectedPaquete || !selectedPaquete.paquete_id) {
      setError('Debe seleccionar un paquete antes de registrar el contrato')
      return
    }

    if (tramitesSeleccionados.length === 0) {
      setError('Debe seleccionar al menos un trámite antes de registrar el contrato')
      return
    }

    const formData = new FormData(e.target)
    agregarDatosEmpresaUsuario(formData)
    setIsSubmitting(true)
    formData.append('proyecto_id', selectedId) // ID del proyecto
    const detalles = []
    const pagos = []

    // Agregar detalles del paquete
    selectedPaquete.secciones.forEach((seccion) => {
      seccion.acciones.forEach((accion) => {
        detalles.push({
          paquete_id: selectedPaquete.paquete_id,
          seccion_id: seccion.seccion_id,
          accion_id: accion.accion_id,
          monto: accion.monto,
        })
      })
    })

    // Agregar detalles al FormData
    detalles.forEach((detalle, index) => {
      formData.append(`detalles[${index}][paquete_id]`, detalle.paquete_id)
      formData.append(`detalles[${index}][seccion_id]`, detalle.seccion_id)
      formData.append(`detalles[${index}][accion_id]`, detalle.accion_id)
      formData.append(`detalles[${index}][monto]`, detalle.monto)
    })

    // Agregar los pagos (cuotas)
    selectedPaquete.cuotas.forEach((cuota, cuotaIndex) => {
      pagos.push({
        numero_cuota: cuota.numero_cuota,
        monto_cuota: cuota.monto_cuota,
      })
    })

    // Agregar pagos al FormData
    pagos.forEach((pago, cuotaIndex) => {
      formData.append(`pagos[${cuotaIndex}][numero_cuota]`, pago.numero_cuota)
      formData.append(`pagos[${cuotaIndex}][monto_cuota]`, pago.monto_cuota)
    })

    // Agregar trámites seleccionados al FormData
    tramitesSeleccionados.forEach((tramite, index) => {
      formData.append(`tramites[${index}][plazo_detalle_id]`, tramite.plazo_detalle_id)
      formData.append(`tramites[${index}][dias]`, tramite.dias)
    })


    // Enviar los datos al backend
    try {
      const respuesta = await consumirApi('POST', 'contrato', formData)

      if (respuesta.success) {
        navigate('/contratos')
      } else {
        setError(respuesta.error)
        setIsSubmitting(false)
      }
    } catch (error) {
      console.error('Error al registrar contrato:', error)
      setError('Ocurrió un error al registrar el contrato')
      setIsSubmitting(false)
    }
  }

  const manejadorClickDerecho = (e, data) => {
    e.preventDefault()
    setContextMenu({
      visible: true,
      x: e.pageX,
      y: e.pageY,
      data,
    })
    setIdProyecto(data.id)
    setEstadoProyecto(data.estado)
  }

  const cambiarEstadoProyecto = async () => {
    await consumirApi('PATCH', `proyecto/cambiar-estado/${idProyecto}`)
    obtenerCotizaciones()
    cerrarContextMenu()
  }

  const cerrarContextMenu = () => {
    setContextMenu({ visible: false, x: 0, y: 0, data: null })
  }

  const manejarCambioFiltro = (e) => {
    setFiltroEstado(e.target.value)
    setSelectedId(null)
    setSelectedEstadoContrato(null)
  }

  const manejarCambioEstadoContrato = (e) => {
    setEstadoContrato(e.target.value)
    setSelectedId(null)
    setSelectedEstadoContrato(null)
  }
  const manejarCambioAnio = (e) => {
    setAnioProyecto(e.target.value)
    setSelectedId(null)
    setSelectedEstadoContrato(null)
  }


  return (
    <div className="w-full min-h-[calc(100vh-50px)]" onClick={cerrarContextMenu} >
      <div className="max-w-full overflow-x-auto flex gap-3 items-center">
        <Button className="ml-5 mt-2" texto="+ Nuevo" onClick={() => navigate('/registrar_cotizacion')} />
        <Button className=" mt-2" texto="COTIZACIÓN" type="delete" disabled={!selectedId} onClick={manejadorPdf} />
        <Button className="mt-2"
          disabled={
            selectedEstadoContrato
              ? true
              : !selectedId
                ? true
                : false
          }
          texto="Generar Contrato" type="report" onClick={manejadorContrato}
        />

        <span className="ml-2 mt-2">Cotización:</span>
        <select className="border rounded-md p-1 mt-2" value={filtroEstado} onChange={manejarCambioFiltro} >
          <option value="1">ACTIVO</option>
          <option value="0">INHABILITADO</option>
          <option value="all">TODOS</option>
        </select>

        <span className="ml-2 mt-2">Contrato:</span>
        <select className="border rounded-md p-1 mt-2" value={estadoContrato} onChange={manejarCambioEstadoContrato} >
          <option value="0">SIN CONTRATO</option>
          <option value="1">CON CONTRATO</option>
          <option value="all">TODOS</option>
        </select>

        <span className="ml-2 mt-2">Año:</span>
        <select className="border rounded-md p-1 mt-2" value={anioProyecto} onChange={manejarCambioAnio} >
          <option value={getYear(new Date())}>{getYear(new Date())}</option>
          <option value={getYear(subYears(new Date(), 1))}>{getYear(subYears(new Date(), 1))}</option>
          <option value={getYear(subYears(new Date(), 2))}>{getYear(subYears(new Date(), 2))}</option>
          <option value="all">TODOS</option>
        </select>
        <FaFileExcel size={30} color="green" className="ml-1 mt-2 inline cursor-pointer" onClick={() => window.open(`${API_BASE_URL}/export/cotizaciones/${idEmpresa}`, "_blank")} />

        {cargandoPdf && <Spinner />}
      </div>

      {notificacion.estado && (
        <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
      )}
      {cargando ? (
        <Spinner />
      ) : datos.length === 0 ? (
        <div className="ml-5 mt-2">No se encontraron Cotizaciones</div>
      ) : (
        <Table
          datos={datos}
          listaCampos={columnas}
          editarRegistro={editarCotizacion}
          manejarClickDerecho={manejadorClickDerecho}
          mostrarChecks={true}
          seleccionFila={seleccionCotizacion} // Manejar el ID seleccionado
          selectedId={selectedId} // Manejar el ID seleccionado
        />
      )}


      {/* Botón flotante para el menú contextual */}
      {contextMenu.visible && (
        <div
          style={{
            position: 'absolute',
            top: contextMenu.y,
            left: contextMenu.x,
            zIndex: 1000,
            padding: '10px',
          }}
        >
          <Button
            texto={
              estadoProyecto
                ? "Inhabilitar cotización"
                : "Habilitar cotización"
            }
            onClick={cambiarEstadoProyecto}
            type={estadoProyecto ? "save" : "report"} // Cambia el tipo aquí
          />
        </div>
      )}

      {/* Modal Generar Contrato */}
      <Modal isOpen={mostrarModalContrato} title="Generar contrato" sizeModal="md" onClose={() => {
        setMostrarModalContrato(false)
        setTramitesSeleccionados([])
        setError('')
      }}>
        <Form onSubmit={registrarContrato} texto="Generar contrato" isSubmitting={isSubmitting}>
          {/* Información General */}
          <Input name="fecha_contrato" value={fechaContrato} label="Fecha de contrato" type="date" onChange={setFechaContrato} />

          {/* Validación: Mostrar Paquetes solo si hay datos */}
          {datosPaquetesCotizacion.cotizaciones && datosPaquetesCotizacion.cotizaciones.length > 0 ? (
            datosPaquetesCotizacion.cotizaciones.map((cotizacion, index) => (
              <div key={index} className="mt-4">
                <h3 className="text-sm font-semibold">Seleccione el paquete elegido</h3>

                <div className="flex gap-2 flex-wrap">
                  {cotizacion.cotizacionDetalle.map((detalle, idx) => (
                    <div key={idx} className="mt-2 w-full">
                      <div className="flex items-center space-x-2">
                        <input
                          type="radio"
                          name="paquete"
                          value={detalle.paquete_id}
                          checked={selectedIdPaquete == detalle.paquete_id}
                          onChange={(e) => seleccionPaquete(e.target.value)}
                          className="w-10 h-4"
                        />
                        <span className="text-sm">{detalle.paquete}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))
          ) : null}

          <div className="my-4">
            <h3 className="text-sm font-semibold">Seleccione los trámites:</h3>
            <div className="space-y-2">
              {Object.keys(groupedTramites).map((tramite) => (
                <label key={tramite} className="mt-2 flex items-center space-x-2">
                  <input
                    type="checkbox"
                    onChange={() => handleChange(tramite)}
                    checked={groupedTramites[tramite].every((item) =>
                      tramitesSeleccionados.some((sel) => sel.plazo_detalle_id === item.plazo_detalle_id)
                    )}
                  />
                  <span>{tramite}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Mostrar error si existe */}
          {error && <ErrorAlert message={error} />}
        </Form>
      </Modal>

    </div>
  )
}

export default Cotizaciones
